import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Paper,
  Typography,
  InputAdornment,
  IconButton,
  CircularProgress,
  Backdrop,
  Snackbar,
  makeStyles
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import axios from "axios";
import SimpleCrypto from "simple-crypto-js";
import { useAlert } from "react-alert";
import Page from "src/components/Page";
import Api from "../../Api";
import localStorageService from "./localStorageService";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: "url('/static/bgLogin.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.45)",
      zIndex: 1,
    },
  },
  paper: {
    position: "relative",
    zIndex: 2,
    padding: theme.spacing(5),
    borderRadius: 16,
    maxWidth: 420,
    width: "100%",
    boxShadow: "0px 8px 30px rgba(0,0,0,0.25)",
    backdropFilter: "blur(6px)",
    backgroundColor: "rgba(255,255,255,0.95)",
  },
  logo: {
    width: 120,
    display: "block",
    margin: "0 auto 20px",
  },
  textField: {
    marginBottom: theme.spacing(2.5),
  },
  button: {
    height: 50,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: "bold",
    background: "linear-gradient(90deg, #3e4396 0%, #5a60cc 100%)",
    color: "#fff",
    "&:hover": {
      background: "linear-gradient(90deg, #33388f 0%, #4a4fb8 100%)",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 2,
    color: "#fff",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LoginView = () => {
  const classes = useStyles();
  const alert = useAlert();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [ipaddress, setIpaddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    const getIP = async () => {
      try {
        const res = await axios.get("https://api64.ipify.org?format=json");
        setIpaddress(res.data.ip || "0.0.0.0");
        sessionStorage.setItem("ip_address", res.data.ip);
      } catch {
        setIpaddress("0.0.0.0");
      }
    };
    getIP();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(`${Api.request.URL}/login`, {
        email: username,
        password,
        ip: ipaddress,
      });

      const simpleCrypto = new SimpleCrypto("some-unique-key");
      const user = {
        nropID: simpleCrypto.encrypt(res.data.details.email),
        diresu: simpleCrypto.encrypt(res.data.details.id),
        emanresu: simpleCrypto.encrypt(res.data.details.firstname),
        namegroup: simpleCrypto.encrypt(res.data.details.lastname),
        drowssp: simpleCrypto.encrypt(password),
        nekton: res.data.token,
        refreshToken: res.data.token,
      };

      localStorage.setItem("token", res.data.token);
      localStorageService.setItem("auth_user", user);
      localStorageService.setItem("userType", res.data.details.user_type);

      window.location.href = "/app/dashboard";
    } catch (error) {
      setOpenSnackbar(true);
      // alert.error(error.response?.data?.errors || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page title="Login">
      <div className={classes.root}>
        <Paper elevation={3} className={classes.paper}>
          <form onSubmit={handleSubmit}>
            <img src="/static/logo140.png" alt="Logo" className={classes.logo} />
            <Typography
              align="center"
              variant="h5"
              gutterBottom
              style={{ fontWeight: 600, color: "#002452" }}
            >
              Welcome Back
            </Typography>
            <Typography
              align="center"
              variant="body2"
              color="textSecondary"
              gutterBottom
            >
              Please sign in to continue
            </Typography>

            <TextField
              className={classes.textField}
              fullWidth
              label="Username"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
            <TextField
              className={classes.textField}
              fullWidth
              label="Password"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                    >
                      {showPassword ? (
                        <Visibility style={{ color: "#3e4396" }} />
                      ) : (
                        <VisibilityOff style={{ color: "#3e4396" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              className={classes.button}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
            </Button>
          </form>
        </Paper>


        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={() => setOpenSnackbar(false)}
        >
          <Alert severity="error" onClose={() => setOpenSnackbar(false)}>
            Invalid username or password
          </Alert>
        </Snackbar>
      </div>
    </Page>
  );
};

export default LoginView;
